import Home from "@/pages/HomePage.vue";
import Login from "@/pages/LoginPage.vue";
import ChangePassword from "@/pages/ChangePasswordPage.vue";
import MinimalSalaryOverview from "@/pages/MinimalSalaryOverview.vue";
import KeywordManagement from "@/pages/KeywordsManagement.vue";
import UeblicherLohnStammdaten from "@/pages/UeblicherLohnStammdaten.vue";
import BranchesManagement from "@/pages/BranchesManagement.vue";
import ContractOverview from "@/pages/ContractOverview.vue";
import CriterionConfiguration from "@/pages/CriterionManagementPage.vue";
import ProfessionContributions from "@/pages/ContractProfessionContributionManagement.vue";
import ValidationRules from "@/pages/ValidationRulesManagement.vue";
import minimumWageConfiguration from "@/pages/ContractMinimumWageConfiguration.vue";
import RssFeedManagement from "@/pages/RssFeedManagement.vue";
import UserManagement from "@/pages/UserManagement.vue";
import CompareContracts from "@/pages/CompareContracts.vue";
import CompareMultipleContractsPage from "@/pages/CompareMultipleContractsPage.vue";
import TopGav from "@/pages/TopGavManagement.vue";
import ValidateAssets from "@/pages/ValidateAssets.vue";
import AuditLog from "@/pages/AuditLog.vue";
import ErrorLog from "@/pages/ErrorLog.vue";
import notFound from "@/pages/404.vue";
import Analyses from "@/pages/Analyses.vue";

import CriteriaPage from "@/components/minimum.wage/pages/Criteria/CriteriaPage.vue";
import CriteriaGroupsPage from "@/components/minimum.wage/pages/CriteriaGroups/CriteriaGroupsPage.vue";
import VariablesPage from "@/components/minimum.wage/pages/Variables/VariablesPage.vue";
import RulesPage from "@/components/minimum.wage/pages/Rules/RulesPage.vue";
import ValidationsPage from "@/components/minimum.wage/pages/Validation/ValidationsPage.vue";
import TextBlocksPage from "@/components/minimum.wage/pages/TextBlocks/TextBlocksPage.vue";
import AlternativeTextPage from "@/components/minimum.wage/pages/AlternativeText/AlternativeTextPage.vue";
import CommentsPage from "@/components/minimum.wage/pages/Comments/CommentsPage.vue";
import CantonalMinimumWagePage from "@/components/legalMinimumWage/LegalMinimumWagePage.vue";
import SettingsPage from "@/components/minimum.wage/pages/Settings/SettingsPage.vue";
//import ZuschlagsConfigurationPage from "@/components/minimum.wage/pages/ZuschlagsConfiguration/ZuschlagsConfiguration.vue";
//import Holidays from "@/components/minimum.wage/pages/Holidays/Holidays.vue";

import ContactsManagement from "@/pages/ContactsManagement.vue";
import AnredenManagement from "@/pages/AnredenManagement.vue";
import OrganisationManagement from "@/pages/OrganisationManagement.vue";
//import ResourceCalendarManagement from "@/pages/ResourceCalendarManagement.vue";
//import WageSupplementTypeConfigurationManagement from "@/pages/WageSupplementTypeConfigurationManagement.vue";
import ContractsAndResponsibilitiesManagement from "@/pages/ContractsAndResponsibilitiesManagement.vue";

export const Routes = [
  {
    path: "/home",
    name: "home",
    components: {
      default: Home,
    },
  },
  {
    path: "/",
    redirect: "/home",
  },

  {
    path: "/keywords",
    name: "keywords",
    components: {
      default: KeywordManagement,
    },
    children: [
      {
        path: ":keywordId",
        component: ContractOverview,
      },
    ],
  },
  {
    path: "/BranchesManagement",
    name: "BranchesManagement",
    components: {
      default: BranchesManagement,
    },
  },
  {
    path: "/UeblicherLohnStammdaten",
    name: "UeblicherLohnStammdaten",
    components: {
      default: UeblicherLohnStammdaten,
    },
  },

  {
    path: "/contract-overview/:vertragsId",
    name: "contract-overview",
    component: ContractOverview,
    children: [
      {
        path: ":versionNumber",
        component: ContractOverview,
        children: [
          {
            path: ":editionId",
            component: ContractOverview,
          },
        ],
      },
    ],
  },
  {
    path: "/contract-overview/:vertragsId/:versionsId/berufsbeitraege",
    name: "ProfessionContributions",
    component: ProfessionContributions,
  },
  {
    path: "/contract-overview/:vertragsId/:versionsId/:editionsId/mindestlohnkonfiguration",
    name: "minimumWageConfiguration",
    component: minimumWageConfiguration,
    children: [
      {
        path: "eingabemaske",
        name: "eingabemaske",
        component: CriteriaPage,
        meta: {
          title: "Eingabemaske",
        },
      },
      {
        path: "eingabegruppierung",
        component: CriteriaGroupsPage,
        meta: {
          title: "Eingabegruppierungen",
        },
      },
      {
        path: "formelnvariabeln",
        component: VariablesPage,
        meta: {
          title: "Formeln & Variablen",
        },
      },
      {
        path: "berechnungsregeln",
        component: RulesPage,
        meta: {
          title: "Berechnungsregeln",
        },
      },
      //{
      //  path: "zuschlagskonfiguration",
      //  component: ZuschlagsConfigurationPage,
      //  meta: {
      //    title: "Zuschlagsrecher Konfiguration",
      //  },
      //},
      //{
      //  path: "feiertage",
      //  component: Holidays,
      //  meta: {
      //    title: "Feiertage",
      //  },
      //},
      {
        path: "validierung",
        component: ValidationsPage,
        meta: {
          title: "Validierung",
        },
      },
      {
        path: "textbloecke",
        component: TextBlocksPage,
        meta: {
          title: "Textblöcke",
        },
      },
      {
        path: "alternativetexte",
        component: AlternativeTextPage,
        meta: {
          title: "Alternativtexte",
        },
      },
      {
        path: "kommentare",
        component: CommentsPage,
        meta: {
          title: "Kommentare",
        },
      },
      {
        path: "einstellungen",
        component: SettingsPage,
        meta: {
          title: "Einstellungen",
        },
      },
    ],
  },
  {
    path: "/klauselKonfiguration",
    name: "klauselKonfiguration",
    components: {
      default: CriterionConfiguration,
    },
  },
  {
    path: "/mindestlohnVerwalten",
    name: "mindestlohnVerwalten",
    components: {
      default: CantonalMinimumWagePage,
    },
  },
  //{
  //  path: "/wageSupplementTypeConfigurationManagement",
  //  name: "wageSupplementTypeConfigurationManagement",
  //  components: {
  //    default: WageSupplementTypeConfigurationManagement,
  //  },
  //},
  {
    path: "/users",
    name: "UserManagement",
    components: {
      default: UserManagement,
    },
    children: [
      {
        path: ":userId",
        components: {
          default: UserManagement,
        },
      },
    ],
  },
  {
    path: "/contacts",
    name: "ContactsManagement",
    component: ContactsManagement,
    children: [
      {
        path: ":action",
        components: {
          default: ContactsManagement,
        },
      },
    ],
  },
  {
    path: "/anrede",
    name: "ContactsManagement",
    component: AnredenManagement,
    children: [
      {
        path: ":action",
        components: {
          default: AnredenManagement,
        },
      },
    ],
  },
  {
    path: "/organisation",
    name: "OrganisationManagement",
    component: OrganisationManagement,
    children: [
      {
        path: ":action",
        components: {
          default: OrganisationManagement,
        },
      },
    ],
  },
  {
    path: "/contractsAndResponsibilities",
    name: "ContractsAndResponsibilitiesManagement",
    components: {
      default: ContractsAndResponsibilitiesManagement,
    },
  },
  //{
  //  path: "/resourceCalendar",
  //  name: "ResourceCalendarManagement",
  //  component: ResourceCalendarManagement,
  //  children: [
  //    {
  //      path: ":action",
  //      components: {
  //        default: ResourceCalendarManagement,
  //      },
  //    },
  //  ],
  //},
  {
    path: "/rssFeedManagement",
    name: "rssFeedManagement",
    components: {
      default: RssFeedManagement,
    },
  },
  {
    path: "/compareContracts",
    name: "compareContracts",
    components: {
      default: CompareContracts,
    },
  },
  {
    path: "/CompareMultipleContracts",
    name: "CompareMultipleContracts",
    components: {
      default: CompareMultipleContractsPage,
    },
  },
  {
    path: "/validierungsRegeln",
    name: "validierungsRegeln",
    components: {
      default: ValidationRules,
    },
  },
  {
    path: "/gesetzlicherMindestlohnUebersicht",
    name: "minimalSalaryOverview",
    components: {
      default: MinimalSalaryOverview,
    },
  },
  {
    path: "/topgav",
    name: "topgav",
    components: {
      default: TopGav,
    },
  },
  {
    path: "/assetsValidieren",
    name: "assetsValidieren",
    components: {
      default: ValidateAssets,
    },
  },
  {
    path: "/auditlog",
    name: "auditlog",
    components: {
      default: AuditLog,
    },
  },
  {
    path: "/errorlog/:scope",
    name: "errorLog",
    components: {
      default: ErrorLog,
    },
  },
  {
    path: "/login",
    name: "login",
    components: {
      default: Login,
    },
  },
  {
    path: "/changePassword",
    name: "changePassword",
    components: {
      default: ChangePassword,
    },
  },
  {
    path: "/page-not-found",

    name: "page-not-found",
    components: {
      default: notFound,
    },
  },
  {
    path: "/auswertung",
    name: "auswertung",
    components: {
      default: Analyses,
    },
  },
  {
    path: "*",
    redirect: "/page-not-found",
  },
];
